<template>
  <app-drawer
    :title="'Attach spare parts to ' + damage.damage_part"
    :isBusy="isLoading"
    ref="drawer"
  >
    <div class="el-drawer__content" v-loading="isLoading">
      <el-form>
        <el-row :gutter="15" v-for="(item, index) in attachments" :key="index">
          <el-col :sm="8">
            <el-form-item label="Part No." :data-status="item.status">
              <!-- <el-select
                v-if="!isReadonly && !locked"
                v-model="item.part_id"
                @change="getPartInfo(item)"
                clearable
                @clear="clearItem(item)"
              > -->
              <el-select
                v-if="!isReadonly && item.status != 1"
                v-model="item.part_id"
                @change="getPartInfo(item)"
                clearable
                @clear="clearItem(item)"
              >
                <el-option
                  v-for="i in approvedRequests"
                  :key="i.id"
                  :label="i.part_no"
                  :value="i.id"
                  :disabled="checkValidity(i)"
                >
                </el-option>
              </el-select>
              <el-input
                v-else
                v-model="item.parts_used.part_no"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item label="Quantity">
              <el-input-number
                v-model="item.quantity"
                :max="item.max"
                :controls="false"
                @change="computeCost(item, $event)"
                :disabled="isReadonly"
                :readonly="isReadonly"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item label="Cost">
              <el-input
                v-model="item.cost"
                :readonly="true"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="damage.id">
          <el-col>
            <app-uploader
              v-if="!isReadonly && !locked"
              url="/api/v1/inventory/fileupload/"
              :params="{ q: 'damages' }"
              @uploadSuccess="handleUploadSuccess(arguments, damage)"
              accept="image/*"
              :multiple="false"
              :limit="3"
              :fileList="damage.files"
              :is-disabled="damage.files.length == 3"
            ></app-uploader>
            <div class="masonry mt-2">
              <masonry :cols="2" :gutter="15">
                <div
                  v-for="(file, index) in damage.files"
                  :key="`img-${index}`"
                >
                  <a
                    v-if="!isReadonly && !locked"
                    href="#"
                    class="text-danger"
                    style="position: absolute; background: #fff; height: 20px; width: 20px"
                    @click="deleteFile(damage, file)"
                  >
                    <i class="el-icon-close"></i>
                  </a>
                  <img :src="getImageSrc(file)" alt="img" />
                </div>
              </masonry>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="el-drawer__footer">
        <el-button size="mini" @click="close">Cancel</el-button>
        <!-- v-if="!isReadonly" -->
        <el-button
          v-if="!isReadonly && !locked"
          size="mini"
          type="primary"
          @click="save"
          >Save</el-button
        >
      </div>
    </div>
  </app-drawer>
</template>

<script>
import ULD from "@/models/ULD";
import User from "@/models/User";
export default {
  name: "damageSpareParts",
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    locked: {
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      damage: { files: [] },
      attachments: [],
      approvedRequests: [],
      tailor: [],
      welder: []
    };
  },
  computed: {
    isReadonly() {
      return this.readonly ? true : false;
    },
    uld() {
      return this.$store.getters["uld/info"];
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {
    library() {
      User.list({ user_type: "tailor", limit: 99999 }).then(resp => {
        this.tailor = resp.data;
      });
      User.list({ user_type: "welder", limit: 99999 }).then(resp => {
        this.welder = resp.data;
      });
    },
    open(damage) {
      this.damage = { tailored_by: "", welded_by: "", files: [] };
      this.attachments = [];
      if (damage) {
        this.damage = { ...damage, files: [] };
        let params = {
          damage_id: damage.id
        };
        this.isLoading = true;
        let promises = [];
        promises.push(
          ULD.get_damage_parts(params).then(resp => {
            if (resp) {
              this.damage.welded_by = resp.data[0].welded_by
                ? parseInt(resp.data[0].welded_by)
                : "";
              this.damage.tailored_by = resp.data[0].tailored_by
                ? parseInt(resp.data[0].tailored_by)
                : "";
              let spare_parts = resp.data[0].spare_parts;
              for (let i of spare_parts) {
                this.attachments.push({
                  id: i.id,
                  part_id: i.parts_used.stockout_id,
                  quantity: i.quantity,
                  // cost: i.quantity * i.parts_used.final_price_aed,
                  cost: (i.quantity * i.parts_used.final_price_usd).toFixed(4),
                  damage_id: damage.id,
                  parts_used: i.parts_used,
                  // max: i.quantity,
                  status: i.status
                });
              }

              resp.data[0].path.forEach(file => {
                this.damage.files.push({
                  path: file.path,
                  url: file.raw
                });
              });
            }
            if (this.attachments.length < 10) {
              let ctr = 10 - this.attachments.length;
              for (ctr; ctr > 0; ctr--) {
                this.attachments.push({
                  part_id: "",
                  quantity: 0,
                  cost: 0,
                  damage_id: damage.id,
                  parts_used: {}
                });
              }
            }

            params = { uld_id: this.uld.id };
            ULD.get_stockout_items(params).then(resp => {
              let list = [];
              if (resp) {
                for (let item of resp) {
                  let _attach = this.attachments.find(
                    o => o.parts_used.part_no == item.part_no
                  );
                  if (_attach) {
                    _attach.max = item.quantity + _attach.quantity;
                  }
                  list.push({
                    ...item,
                    max: item.quantity
                  });
                }
              }
              this.approvedRequests = list;
              this.isLoading = false;
            });
          })
        );

        // promises.push(

        // );
        // Promise.all(promises).then(() => {
        //   this.isLoading = false;
        // });
      }
      this.$refs.drawer.open();
    },
    close() {
      this.damage = { files: [] };
      this.attachments = [];
      this.$refs.drawer.close();
    },
    getPartInfo(item) {
      if (item.part_id) {
        let request = this.approvedRequests.find(o => o.id == item.part_id);
        if (request) {
          item.quantity = request.quantity;
          item.max = request.max;
          item.cost = (
            item.quantity * parseFloat(request.final_price_usd)
          ).toFixed(4);
        }
        // item.status = 1;
      } else {
        item.cost = 0;
        item.quantity = 0;
        item.max = null;
      }
    },
    checkValidity(sparePart) {
      let check = this.attachments.find(o => o.part_id == sparePart.id);
      if (check) return true;
      return false;
    },
    computeCost(item, $value) {
      if ($value > item.max) {
        item.quantity = item.max;
      }
      if (item.part_id) {
        let request = this.approvedRequests.find(o => o.id == item.part_id);
        if (request) {
          // item.cost = item.quantity * parseFloat(request.final_price_aed);
          let cost = item.quantity * parseFloat(request.final_price_usd);
          item.cost = cost.toFixed(4);
        } else {
          let cost =
            item.quantity * parseFloat(item.parts_used.final_price_usd);
          item.cost = cost.toFixed(4);
        }
      } else {
        item.quantity = 0;
        item.cost = 0;
      }
    },
    save() {
      this.$confirm("Do you want to save the parts attached to this damage?")
        .then(() => {
          let list = this.attachments.filter(o => o.part_id != "" || "id" in o);
          // if (list.length) {
          this.isLoading = true;
          let promises = [];

          let damage = { ...this.damage };
          if (!damage.welded_by) damage.welded_by = null;
          if (!damage.tailored_by) damage.tailored_by = null;

          let urls = [];
          for (let file of damage.files) {
            urls.push(file.url);
          }
          damage.path = urls.join(",");

          let damagePayload = {
            id: this.uld.id,
            damages: [damage]
          };

          promises.push(ULD.update(damagePayload));

          for (let i of list) {
            let payload = {
              id: i.id,
              quantity: i.quantity,
              cost: i.cost,
              damage_id: i.damage_id,
              stockout_id: i.part_id
              // status: i.part_id ? 1 : 0
            };
            if (i.status == 404) {
              payload = {
                status: 404,
                id: i.id
              };
            }

            if (payload.id) {
              promises.push(ULD.update_damage_parts(payload));
            } else {
              promises.push(ULD.create_damage_parts(payload));
            }
          }
          Promise.all(promises).then(() => {
            this.$store.dispatch("uld/fetchDamages", this.uld.id);
            this.isLoading = false;
            this.$notify({
              type: "success",
              message: "Damage attachments saved.",
              position: "bottom-right"
            });
            this.close();
          });
        })
        .catch(() => {});
    },
    handleUploadSuccess(resp, damage) {
      let res = resp[0],
        file = resp[1];
      let s = file.name.split(".");
      s.pop();
      let filename = s.join("");

      let obj = {
        _file: file,
        name: filename,
        url: res.data.msg
      };
      damage.files.push(obj);
    },
    deleteFile(damage, file) {
      if(!this.isRole([3])) damage.files = damage.files.filter(o => o.url != file.url);
    },
    viewImage(file) {
      // console.log(file);
      var image = new Image();
      image.src = URL.createObjectURL(file._file.raw);

      var w = window.open("");
      w.document.write(image.outerHTML);
      // window.open(URL.createObjectURL(file._file.raw));
    },
    getImageSrc(file) {
      if ("_file" in file) return URL.createObjectURL(file._file.raw);
      else return "data:image/jpg;base64," + file.path;
    },
    itemExists(item) {
      if (!item.part_id) return true;
      let check = this.approvedRequests.find(
        o => o.part_no == item.parts_used.part_no
      );
      if (check) return true;

      return false;
    },
    clearItem(item) {
      item.status = 404;
      let _dItem = this.damage.spare_parts.find(o => o.id == item.id);
      if (_dItem) {
        let _item = this.approvedRequests.find(
          o => o.part_no == _dItem.parts_used.part_no
        );
        if (_item) {
          _item.max = _dItem.quantity + _item.quantity;
          item.max = _item.max;
        }
      }
    }
  },
  mounted() {
    // this.library();
  }
};
</script>

<style lang="css" scoped></style>
